import { render, staticRenderFns } from "./ShiftsItem.vue?vue&type=template&id=ce1ed15c&lang=pug"
import script from "./ShiftsItem.vue?vue&type=script&lang=js"
export * from "./ShiftsItem.vue?vue&type=script&lang=js"
import style0 from "./ShiftsItem.vue?vue&type=style&index=0&id=ce1ed15c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports